import { DataSource } from "./Field";
import FruitField from "./FruitField";

export default class FruitPressureField extends FruitField {

    splitter = " - ";

    set_value(datasource: DataSource): this {
        const { fruit } = datasource;
        if (!fruit) {
            this.value = null;
            return this;
        }
        if (fruit.pressure_1 || fruit.pressure_2) {
            this.value = `${fruit.pressure_1}${this.splitter}${fruit.pressure_2}`;
        } else {
            this.value = fruit.pressure;
        }
        if (fruit.pressure) {
            this.set_classname("fw-bold");
        }
        this.datasource = datasource;
        return this;
    }

}
